import React from "react";
import PropTypes from "prop-types";
import { Grid, makeStyles, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { eurCurrency } from "constants/currency";
import assetPageStyle from "features/assets/styles";

const useStyles = makeStyles(assetPageStyle);

function ExtraInformation({ quote, showValuesInEuro }) {
  const { t } = useTranslation();
  const classes = useStyles();
  const xs = showValuesInEuro ? 6 : 5;
  const lg = showValuesInEuro ? 4 : 3;

  return (
    <Grid container justifyContent="flex-end">
      {quote.showAmountsWithVAT ? (
        <Grid item container xs={xs} lg={lg} direction="row" justifyContent="space-between" alignItems="center">
          <Grid item xs={6}>
            <Typography className={classes.total}>{t("Asset.TotalAmountWithVAT")}</Typography>
          </Grid>
          {!showValuesInEuro && (
            <Grid item xs={6}>
              <Typography className={classes.total}>
                {quote.currencyCode} {t("DECIMAL2", { number: quote.totalAmountWithVAT })}
              </Typography>
            </Grid>
          )}
          {showValuesInEuro && (
            <>
              <Grid item xs={6}>
                <Typography className={classes.total}>
                  {quote.currencyCode} {t("DECIMAL2", { number: quote.totalAmountWithVAT })} ( {eurCurrency.code}{" "}
                  {t("DECIMAL2", { number: (quote.totalAmountWithVAT || 0) / quote.exchangeRate })} )
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography className={classes.total}>{t("Asset.ExchangeRate")}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography className={classes.total}>
                  {quote.exchangeRate} ({quote.currencyCode}/{eurCurrency.code})
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography className={classes.total}>{t("Asset.ExchangeRateDate")}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography className={classes.total}>
                  {t("DATE_FORMAT", { date: { value: quote.exchangeRateDate, format: "DD.MM.YYYY" } })}
                </Typography>
              </Grid>
            </>
          )}
        </Grid>
      ) : (
        <Grid item container xs={xs} lg={lg} direction="row" justifyContent="space-between" alignItems="center">
          <Grid item xs={6}>
            <Typography className={classes.total}>{t("Asset.TotalAmount")}</Typography>
          </Grid>
          {!showValuesInEuro && (
            <Grid item xs={6}>
              <Typography className={classes.total}>
                {quote.currencyCode} {t("DECIMAL2", { number: quote.totalAmount })}
              </Typography>
            </Grid>
          )}
          {showValuesInEuro && (
            <>
              <Grid item xs={6}>
                <Typography className={classes.total}>
                  {quote.currencyCode} {t("DECIMAL2", { number: quote.totalAmount })} ( {eurCurrency.code}{" "}
                  {t("DECIMAL2", { number: (quote.totalAmount || 0) / quote.exchangeRate })})
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography className={classes.total}>{t("Asset.ExchangeRate")}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography className={classes.total}>
                  {quote.exchangeRate} ( {quote.currencyCode}/{eurCurrency.code} )
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography className={classes.total}>{t("Asset.ExchangeRateDate")}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography className={classes.total}>
                  {t("DATE_FORMAT", { date: { value: quote.exchangeRateDate, format: "DD.MM.YYYY" } })}
                </Typography>
              </Grid>
            </>
          )}
        </Grid>
      )}
    </Grid>
  );
}

ExtraInformation.propTypes = {
  quote: PropTypes.object.isRequired,
  showValuesInEuro: PropTypes.bool.isRequired,
};

export default ExtraInformation;
